import baseAPI from '@/api/base';
import {
  EditWeeklyEvent,
  GetWeeklyEvent,
  RegisterWeeklyEvent,
} from '@/dtos/weekly_event.dto';
import {
  DELETE_WEEKLY_EVENT_URL,
  EDIT_WEEKLY_EVENT_URL,
  GET_WEEKLY_EVENT_URL,
  REGISTER_WEEKLY_EVENT_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class WeeklyEvent {
  static getWeeklyEvents = async (
    getWeeklyEvent: GetWeeklyEvent
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_WEEKLY_EVENT_URL, {
      params: getWeeklyEvent,
    });
    console.log('response', response);
    return response;
  };

  static registerWeeklyEvent = async (
    registerWeeklyEvent: RegisterWeeklyEvent
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      REGISTER_WEEKLY_EVENT_URL,
      registerWeeklyEvent
    );
    console.log('response', response);
    return response;
  };

  static editWeeklyEvent = async (
    editWeeklyEvent: EditWeeklyEvent
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      EDIT_WEEKLY_EVENT_URL,
      editWeeklyEvent
    );
    return response;
  };

  static deleteWeeklyEvent = async (
    id: string
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_WEEKLY_EVENT_URL}/${id}`
    );
    return response;
  };
}

export default WeeklyEvent;

